(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyPaymentLogCustom', CompanyPaymentLogCustom);

    CompanyPaymentLogCustom.$inject = ['$resource'];

    function CompanyPaymentLogCustom($resource) {


        var getActiveCompanyPaymentLogs = function () {
            var resourceUrl = 'api/get-active-company-payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyPaymentLogs = function () {
            var resourceUrl = 'api/get-company-payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };

        var getCompanyPaymentLogsByAccountClearingRequestId = function (accountClearingRequestId) {
            var resourceUrl = 'api/get-company-payment-logs-by-account-clearing-request-id?accountClearingRequestId=' + accountClearingRequestId;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
        var getCompanyPaymentLogList = function() {
            var resourceUrl = 'api/_search/payment-logs';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        }

        var updateCompanyPayment = function(id) {
            var resourceUrl = "api/payment-logs/"+ id +"/approval"
            return $resource(resourceUrl, {}, {
                    'update': { method: 'PUT' }
                })
        }


        return {
            getActiveCompanyPaymentLogs: getActiveCompanyPaymentLogs,
            getCompanyPaymentLogs: getCompanyPaymentLogs,
            getCompanyPaymentLogsByAccountClearingRequestId: getCompanyPaymentLogsByAccountClearingRequestId,
            getCompanyPaymentLogList: getCompanyPaymentLogList,
            updateCompanyPayment: updateCompanyPayment

        };
    }
})();
